import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { generateUuid } from '@core/utils-legacy';

@Component({
  selector: 'rt-screening-icon',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <svg
      [attr.width]="size()"
      [attr.height]="size()"
      viewBox="0 0 33 33"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient [attr.id]="svgId">
          <stop offset="0" stop-color="var(--color-icon-ai-default)" />
          <stop [attr.offset]="fillAmount()" stop-color="var(--color-icon-ai-default)" />
          <stop [attr.offset]="fillAmount()" stop-color="var(--color-icon-disabled)" />
          <stop offset="1" stop-color="var(--color-icon-disabled)" />
        </linearGradient>
        <clipPath id="shape" transform="rotate(-30 16 16)">
          <path
            d="M29.4857 8.10842C30.1415 9.13094 30.6752 10.2209 31.0814 11.3545L18.8724 32.5029C17.6868 32.7182 16.4753 32.8019 15.2611 32.7451L29.4857 8.10842ZM25.2933 3.71779C26.1388 4.31737 26.9101 4.98782 27.6048 5.71584L12.2484 32.3125C11.271 32.0749 10.3052 31.7418 9.36363 31.3096L25.2933 3.71779ZM31.9701 15.4668C32.2265 18.5968 31.5684 21.8341 29.8793 24.7598C28.1899 27.6859 25.7148 29.8749 22.8754 31.2178L31.9701 15.4668ZM19.9779 1.251C20.9536 1.50046 21.9165 1.84661 22.8548 2.29103L6.90856 29.9121C6.05436 29.3217 5.2737 28.6598 4.56969 27.9395L19.9779 1.251ZM13.4125 0.971698C14.5872 0.776861 15.7859 0.712735 16.9857 0.784198L2.6693 25.5811C2.00766 24.5779 1.46385 23.5081 1.04527 22.3936L13.4125 0.971698ZM0.101915 18.3779C-0.229285 15.1473 0.416555 11.7862 2.16441 8.75881C3.91222 5.73152 6.49997 3.49163 9.46324 2.1631L0.101915 18.3779Z"
          />
          <path
            d="M19.8562 1.3943C19.9054 1.30898 20.0055 1.26672 20.1007 1.29214C20.9439 1.51737 21.7771 1.81511 22.5924 2.18666C22.7093 2.2399 22.7536 2.38234 22.6894 2.49353L7.01372 29.6442C6.94953 29.7553 6.80399 29.7881 6.69948 29.7136C5.97017 29.1932 5.29618 28.62 4.6796 28.0023C4.61 27.9326 4.59656 27.8248 4.64582 27.7395L19.8562 1.3943ZM13.3329 1.06158C13.3657 1.00466 13.4223 0.965352 13.4872 0.955012C14.5115 0.79186 15.5534 0.727992 16.5979 0.766957C16.7611 0.773047 16.857 0.950711 16.7753 1.0922L2.84387 25.2222C2.76218 25.3637 2.56039 25.3696 2.47348 25.2312C1.91748 24.3462 1.45158 23.4122 1.08076 22.4437C1.05726 22.3824 1.063 22.3137 1.09586 22.2568L13.3329 1.06158ZM0.442302 17.7485C0.335716 17.9331 0.0604538 17.8725 0.0477848 17.6597C-0.131564 14.6473 0.539433 11.5501 2.16114 8.74121C3.78305 5.93209 6.12977 3.80212 8.82855 2.45127C9.01917 2.35586 9.20925 2.56396 9.10267 2.74856L0.442302 18.7485Z"
          />
        </clipPath>
      </defs>
      <rect
        transform="rotate(30 16 16)"
        x="0"
        y="0"
        [attr.fill]="'url(#' + svgId + ')'"
        width="100%"
        height="100%"
        clip-path="url(#shape)"
      />
    </svg>
  `,
  styles: [
    `
      :host {
        display: inline-flex;
      }
    `,
  ],
})
export class ScreeningIconComponent {
  // value 0-1
  public fillAmount = input(0);
  public size = input(32);

  protected svgId = generateUuid();
}
